import { AriaRole } from 'react';

import { getRouteV2 } from 'Config';

import type { FormatMessagePayload } from 'Store/updates/constants';

import { NotificationTheme } from 'Components/InAppNotification/constants';

import { AvatarShapeType } from '../../components/Avatar/types';
import { User } from '../profile/user.types';
import { MatchType } from '../updates/constants';

export enum NotificationType {
  inApp = 'inApp',
  browser = 'browser',
}

export type NotificationItem = {
  body: string | [FormatMessagePayload, Record<string, any>?] | undefined;
  category?: string;
  context?: Record<'userName', User['username']>;
  icon?: string[] | string | React.ComponentType<any> | null;
  options?: Partial<Options>;
  role?: AriaRole;
  target?: NotificationType;
  title?: Record<'id', string>[] | string | [FormatMessagePayload, Record<string, any>?];
  theme?: NotificationTheme | undefined;
  timestamp?: number;
};

export type NotificationState = {
  items: NotificationItem[];
  notificationType?: NotificationType;
  pushId?: string;
  showTooltip?: boolean;
  replyReminderShown?: boolean;
};

interface Options extends NotificationOptions {
  ttl: number;
  onClick: () => void;
  modalType: string;
  modalProps: Record<string, any>;
  route: ReturnType<typeof getRouteV2> | null;
  avatarShape: AvatarShapeType;
  avatarType: MatchType;
  wrapText: boolean;
}
